module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4y98m"))).then(() => parcelRequire('d0iPb'));